import type { ApplyStatusType } from '@/types/domain/childApply/valueObjects/applyStatus';

import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * ステータス申請
 */
export class ApplyStatus extends PrimitiveValueObject<ApplyStatusType> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: ApplyStatusType): ApplyStatus {
    return new ApplyStatus(value);
  }

  /** ラベル */
  static get label(): string {
    return '申請状態';
  }

  /** タイプ */
  static get type() {
    return 'text';
  }

  /** キー */
  static get key() {
    return 'applyStatus';
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
